import { isPlatformBrowser, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { AfterViewInit, Component, Inject, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { GoogleAnalyticsService } from './shared/services';
import { FooterComponent } from './core/footer/footer.component';
import { GoogleAnalyticsGTagComponent } from './core/google-analytics-tag/google-analytics-tag.component';
import { HeaderComponent } from './core/header/header.component';

let navigator: Navigator;
try
{ navigator = window.navigator; }
catch
{ console.info('No window found!'); }

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    GoogleAnalyticsGTagComponent,
    RouterOutlet,
    NgSwitch,
    NgSwitchCase,
    NgIf,
  ],
  providers: [],
})
export class AppComponent implements AfterViewInit
{
  navigator = navigator ? navigator : undefined;

  notNavigatorLanguage = navigator ? !navigator.language.startsWith(this.locale) : false;

  subscriptions = new Subscription();

  constructor(

    @Inject(PLATFORM_ID) private readonly platformId: object,
    @Inject(LOCALE_ID) public locale: string,
    public router: Router,
    public googleAnalyticsService: GoogleAnalyticsService,
  )
  {

  }

  ngAfterViewInit(): void
  {
    this.subscriptions.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
      ).subscribe((event) =>
      {
        if (isPlatformBrowser(this.platformId) && event instanceof NavigationEnd)
        {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          gtag('config', this.googleAnalyticsService.trackingCode, { page_path: event.urlAfterRedirects });
        }
      },
      ),
    );
  }
}
